import { render, staticRenderFns } from "./Skills.vue?vue&type=template&id=6f2c06e8&scoped=true&"
import script from "./Skills.vue?vue&type=script&lang=js&"
export * from "./Skills.vue?vue&type=script&lang=js&"
import style1 from "./Skills.vue?vue&type=style&index=1&id=6f2c06e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2c06e8",
  null
  
)

export default component.exports